import React from "react";
import { SITE } from "../data/site";

/**
 * Official Exotik Trips brand assets.
 *  - variant "primary" → for light backgrounds (blue lettering + turquoise flower)
 *  - variant "light"   → cream/beige version for dark backgrounds (footer, dark heroes)
 */
export default function BrandLogo({ variant = "primary", height = 56, className = "" }) {
    const src = variant === "light" ? SITE.logoSecondaryUrl : SITE.logoPrimaryUrl;
    return (
        <img
            src={src}
            alt="Exotik Trips"
            style={{ height, width: "auto" }}
            className={`select-none ${className}`}
            draggable={false}
        />
    );
}

/**
 * Official flower symbol — turquoise pinwheel.
 * Perfect for compact usages (favicon, mobile app icon) and decorative filigrees.
 * Use `tint="cream"` on dark backgrounds to keep contrast (via CSS filter fallback).
 */
export function BrandSymbol({ size = 64, className = "", style = {}, tint }) {
    let filter;
    switch (tint) {
        case "cream":
            filter = "brightness(0) saturate(100%) invert(97%) sepia(6%) saturate(447%) hue-rotate(2deg) brightness(103%) contrast(96%)";
            break;
        case "ocean":
            filter = "brightness(0) saturate(100%) invert(34%) sepia(60%) saturate(1057%) hue-rotate(178deg) brightness(88%) contrast(87%)";
            break;
        case "coral":
            filter = "brightness(0) saturate(100%) invert(56%) sepia(41%) saturate(2822%) hue-rotate(340deg) brightness(93%) contrast(93%)";
            break;
        default:
            filter = undefined;
    }
    return (
        <img
            src={SITE.symbolUrl}
            alt=""
            aria-hidden="true"
            width={size}
            height={size}
            style={{ width: size, height: size, filter, ...style }}
            className={`select-none pointer-events-none ${className}`}
            draggable={false}
        />
    );
}

/** Legacy named export kept as alias in case older imports exist */
export { BrandSymbol as BrandBadge };
